/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_Multilingual_NoteInputs */



/**
* | output |
* | --- |
* | "ElevenLabs voices are multilingual — they speak the language of your text." |
*
* @param {Voice_Manager_Elevenlabs_Multilingual_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_multilingual_note = /** @type {((inputs?: Voice_Manager_Elevenlabs_Multilingual_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_Multilingual_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les voix ElevenLabs sont multilingues : elles parlent la langue de votre texte.")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs-Stimmen sind mehrsprachig – sie sprechen die Sprache Ihres Textes.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le voci ElevenLabs sono multilingue: parlano la lingua del tuo testo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Голоса ElevenLabs многоязычные — они говорят на языке вашего текста.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las voces de ElevenLabs son multilingües: hablan el idioma de tu texto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ElevenLabs 语音支持多语言，会使用文本的语言朗读。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs の音声は多言語対応で、テキストの言語で話します。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ElevenLabs आवाज़ें बहुभाषी हैं — वे आपके टेक्स्ट की भाषा बोलती हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As vozes da ElevenLabs são multilingues: falam o idioma do seu texto.")
	return /** @type {LocalizedString} */ ("ElevenLabs voices are multilingual — they speak the language of your text.")
});